module.exports = __webpack_public_path__ + "static/media/logonaranja.0479f453.jpg";